import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two all-projects" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }
const _hoisted_6 = { class: "text-body" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex-grow-1 ms-2 position-relative top-1" }
const _hoisted_10 = { class: "mb-0 fs-14 fw-medium" }
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = { class: "text-body" }
const _hoisted_13 = { class: "text-body" }
const _hoisted_14 = { class: "d-flex align-items-center gap-1" }
const _hoisted_15 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_16 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_17 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_18 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_19 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_20 = { class: "material-symbols-outlined fs-16 text-danger" }
const _hoisted_21 = { class: "p-4 pt-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"p-4\"><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3\"><h3 class=\"mb-0\">Courses</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>All Courses</option><option value=\"1\">UI/UX</option><option value=\"2\">Wordpress</option></select></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "ID"),
                _createElementVNode("th", { scope: "col" }, "Course Name"),
                _createElementVNode("th", { scope: "col" }, "Category"),
                _createElementVNode("th", { scope: "col" }, "Instructor"),
                _createElementVNode("th", { scope: "col" }, "Enrolled"),
                _createElementVNode("th", { scope: "col" }, "Start Date"),
                _createElementVNode("th", { scope: "col" }, "End Date"),
                _createElementVNode("th", { scope: "col" }, "Price"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.slice(0, 6), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(item.id), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, { to: "/lms/course-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.courseName), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.category), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/lms/instructors",
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            src: item.instructor.image,
                            class: "wh-34 rounded-circle",
                            alt: "user"
                          }, null, 8, _hoisted_8)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h6", _hoisted_10, _toDisplayString(item.instructor.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.enrolled), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(item.startDate), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.endDate), 1),
                  _createElementVNode("td", null, "$" + _toDisplayString(item.price), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("button", _hoisted_15, [
                        _createElementVNode("i", _hoisted_16, _toDisplayString(item.action.view), 1)
                      ]),
                      _createElementVNode("button", _hoisted_17, [
                        _createElementVNode("i", _hoisted_18, _toDisplayString(item.action.edit), 1)
                      ]),
                      _createElementVNode("button", _hoisted_19, [
                        _createElementVNode("i", _hoisted_20, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_Pagination, {
            items: "6",
            total: _ctx.items.length
          }, null, 8, ["total"])
        ])
      ])
    ])
  ]))
}